<div class="section-wrapper">
    <div class="bg-overlay bg-position">
      <div class="red-overlay bg-position"></div>
    </div>
    <div class="card-wrapper container">
        <flo-plans-promo-card 
          [offers]="offers" 
          [isPlansVariation]="isPlansVariation"
          [sportName]="sportName" 
          (offerSelected)="onOfferSelected($event)"
          (signupSelected)="onSignupSelected()"
        >
        </flo-plans-promo-card>
    </div>
</div>